"use client";

import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import { useEmoji } from "@/contexts/EmojiContext";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropReaction } from "@/hooks/drops/useDropReaction";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
const WaveDropActionsAddReaction: React.FC<{
  readonly drop: ExtendedDrop;
  readonly isMobile?: boolean | undefined;
  readonly onAddReaction?: (() => void) | undefined;
  readonly dialogZIndexClassName?: string | undefined;
  readonly size?: "default" | "compact" | undefined;
  readonly updateCurationCache?: boolean | undefined;
}> = t0 => {
  const $ = _c(57);
  const {
    drop,
    isMobile: t1,
    onAddReaction,
    dialogZIndexClassName,
    size: t2,
    updateCurationCache: t3
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  const updateCurationCache = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== onAddReaction || $[1] !== updateCurationCache) {
    t4 = {
      source: "picker",
      onSuccess: onAddReaction,
      updateCurationCache
    };
    $[0] = onAddReaction;
    $[1] = updateCurationCache;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    react,
    canReact
  } = useDropReaction(drop, t4);
  const [showPicker, setShowPicker] = useState(false);
  const buttonRef = useRef(null);
  const pickerContainerRef = useRef(null);
  const {
    emojiMap,
    categories,
    categoryIcons
  } = useEmoji();
  const desktopIconSizeClass = size === "compact" ? "tw-size-4" : "tw-size-5";
  let t5;
  if ($[3] !== react) {
    t5 = emoji => {
      const emojiText = `:${emoji.id ?? ""}:`;
      setShowPicker(false);
      react(emojiText);
    };
    $[3] = react;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleEmojiSelect = t5;
  let t6;
  let t7;
  if ($[5] !== showPicker) {
    t6 = () => {
      const handleClickOutside = event => {
        const target = event.target as Node;
        if (showPicker && pickerContainerRef.current && !pickerContainerRef.current.contains(target) && buttonRef.current && !buttonRef.current.contains(target)) {
          setShowPicker(false);
        }
      };
      const handleEscape = event_0 => {
        if (event_0.key === "Escape" && showPicker) {
          setShowPicker(false);
        }
      };
      if (showPicker) {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleEscape);
      };
    };
    t7 = [showPicker];
    $[5] = showPicker;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  if ($[8] !== canReact || $[9] !== showPicker) {
    t8 = () => {
      if (!canReact) {
        return;
      }
      setShowPicker(!showPicker);
    };
    $[8] = canReact;
    $[9] = showPicker;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const onReact = t8;
  const t9 = `tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${canReact ? "active:tw-bg-iron-800" : "tw-cursor-default tw-opacity-50"} tw-transition-colors tw-duration-200`;
  const t10 = !canReact;
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <svg className="tw-size-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><g transform="scale(0.024)"><path d="M958 104h-62V43q0-17-12-29T855 2h-87q-17 0-29 12t-12 29v61h-62q-17 0-29 12t-12 29v4q-81-34-169-34-116 0-217 59-97 57-154 154-58 100-58 216.5T84 761q57 98 154 155 101 58 217.5 58T672 916q97-57 154-155 59-100 59-216 0-88-34-168h4q17 0 29-12t12-29v-62h62q17 0 29-12t12-29v-88q0-17-12-29t-29-12zM644 348q29 0 49.5 20.5t20.5 49-20.5 49T644 487t-49.5-20.5-20.5-49 20.5-49T644 348zm-377 0q29 0 49.5 20.5t20.5 49-20.5 49T267 487t-49.5-20.5-20.5-49 20.5-49T267 348zm473 255q-10 70-50.5 126.5t-102 88.5-132 32-132-32-102-88.5T171 603q-2-16 8.5-27.5T206 564h499q16 0 26.5 11.5T740 603zm218-370H855v103h-87V233H665v-88h103V43h87v102h103v88z" /></g></svg>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = drop.context_profile_context?.reaction ? "Update Reaction" : "Add Reaction";
  let t13;
  if ($[12] !== t12) {
    t13 = <span className="tw-text-base tw-font-semibold tw-text-iron-300">{t12}</span>;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== onReact || $[15] !== t10 || $[16] !== t13 || $[17] !== t9) {
    t14 = <button className={t9} onClick={onReact} disabled={t10}>{t11}{t13}</button>;
    $[14] = onReact;
    $[15] = t10;
    $[16] = t13;
    $[17] = t9;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const mobileContent = t14;
  const t15 = `picker-button tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-[#FFCC22] ${canReact ? "tw-cursor-pointer" : "tw-cursor-default tw-opacity-50"}`;
  const t16 = !canReact;
  let t17;
  if ($[19] !== canReact || $[20] !== drop.id) {
    t17 = canReact ? {
      "data-tooltip-id": `add-reaction-${drop.id}`
    } : {};
    $[19] = canReact;
    $[20] = drop.id;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  const t18 = `${desktopIconSizeClass} tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out ${!canReact && "tw-opacity-50"}`;
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <g transform="scale(0.024)"><path d="M958 104h-62V43q0-17-12-29T855 2h-87q-17 0-29 12t-12 29v61h-62q-17 0-29 12t-12 29v4q-81-34-169-34-116 0-217 59-97 57-154 154-58 100-58 216.5T84 761q57 98 154 155 101 58 217.5 58T672 916q97-57 154-155 59-100 59-216 0-88-34-168h4q17 0 29-12t12-29v-62h62q17 0 29-12t12-29v-88q0-17-12-29t-29-12zM644 348q29 0 49.5 20.5t20.5 49-20.5 49T644 487t-49.5-20.5-20.5-49 20.5-49T644 348zm-377 0q29 0 49.5 20.5t20.5 49-20.5 49T267 487t-49.5-20.5-20.5-49 20.5-49T267 348zm473 255q-10 70-50.5 126.5t-102 88.5-132 32-132-32-102-88.5T171 603q-2-16 8.5-27.5T206 564h499q16 0 26.5 11.5T740 603zm218-370H855v103h-87V233H665v-88h103V43h87v102h103v88z" /></g>;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t18) {
    t20 = <svg className={t18} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">{t19}</svg>;
    $[23] = t18;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== onReact || $[26] !== t15 || $[27] !== t16 || $[28] !== t17 || $[29] !== t20) {
    t21 = <button ref={buttonRef} className={t15} onClick={onReact} disabled={t16} aria-label="Add reaction to drop" {...t17}>{t20}</button>;
    $[25] = onReact;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
    $[29] = t20;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== canReact || $[32] !== drop.context_profile_context?.reaction || $[33] !== drop.id) {
    t22 = canReact && <Tooltip id={`add-reaction-${drop.id}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">{drop.context_profile_context?.reaction ? "Update Reaction" : "Add Reaction"}</span></Tooltip>;
    $[31] = canReact;
    $[32] = drop.context_profile_context?.reaction;
    $[33] = drop.id;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t21 || $[36] !== t22) {
    t23 = <>{t21}{t22}</>;
    $[35] = t21;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  const desktopContent = t23;
  const t24 = isMobile ? mobileContent : desktopContent;
  let t25;
  if ($[38] !== categories || $[39] !== categoryIcons || $[40] !== emojiMap || $[41] !== handleEmojiSelect || $[42] !== isMobile || $[43] !== showPicker) {
    t25 = !isMobile && showPicker && createPortal(<div className="tw-fixed tw-inset-0 tw-z-1000 tw-flex tw-items-center tw-justify-center tw-bg-black/50"><div ref={pickerContainerRef} className="tw-rounded-lg tw-bg-iron-800 tw-p-px tw-shadow-lg"><Picker theme="dark" data={data} onEmojiSelect={handleEmojiSelect} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div></div>, document.body);
    $[38] = categories;
    $[39] = categoryIcons;
    $[40] = emojiMap;
    $[41] = handleEmojiSelect;
    $[42] = isMobile;
    $[43] = showPicker;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== categories || $[46] !== categoryIcons || $[47] !== dialogZIndexClassName || $[48] !== emojiMap || $[49] !== handleEmojiSelect || $[50] !== isMobile || $[51] !== showPicker) {
    t26 = isMobile && <MobileWrapperDialog isOpen={showPicker} onClose={() => setShowPicker(false)} zIndexClassName={dialogZIndexClassName}><div className="tw-flex tw-size-full tw-items-center tw-justify-center" onTouchMove={_temp}><Picker theme="dark" data={data} onEmojiSelect={handleEmojiSelect} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div></MobileWrapperDialog>;
    $[45] = categories;
    $[46] = categoryIcons;
    $[47] = dialogZIndexClassName;
    $[48] = emojiMap;
    $[49] = handleEmojiSelect;
    $[50] = isMobile;
    $[51] = showPicker;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t24 || $[54] !== t25 || $[55] !== t26) {
    t27 = <>{t24}{t25}{t26}</>;
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  return t27;
};
export default WaveDropActionsAddReaction;
function _temp(e) {
  return e.stopPropagation();
}